import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCoSXTinPOdm1WkfZb6jvSTsWulm8BURNE",
  authDomain: "hqm-dev.firebaseapp.com",
  databaseURL: "https://hqm-dev-default-rtdb.firebaseio.com",
  projectId: "hqm-dev",
  storageBucket: "hqm-dev.firebasestorage.app",
  messagingSenderId: "86147103044",
  appId: "1:86147103044:web:1d2e9125782d12a3677f11"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);

export default app;